import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { MenuDTO } from 'src/app/admihair/api/dto/menu-dto';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MenuServiceProjeto } from 'src/app/admihair/service/menu.service';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';

@Component({
  selector: 'app-menu-inserir',
  templateUrl: './menu-inserir.component.html',
  styleUrls: ['./menu-inserir.component.scss']
})
export class MenuInserirComponent implements OnInit {
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  menus: MenuDTO[] = [];
  permissoes: SelectItem[] = [];
  valorExclusivoRfarias: boolean = false;


  constructor(private permissaoService: PermissaoService,
    private menuService: MenuServiceProjeto,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.listarMenus();
    this.listarPermissoes();
  }

  salvar(){
    this.progressoRequisicao = true;
    let menu : MenuDTO = this.form?.value;
    menu.status = true;
    menu.exclusivoRfarias = menu.exclusivoRfarias ?? false;
    this.menuService.salvar(menu).subscribe({
      next: (data: MenuDTO) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });
  }

  listarMenus(){
    this.menuService.listarTodos().subscribe({
      next: (data: MenuDTO[]) => {
        this.menus = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  listarPermissoes(){
    this.permissaoService.listarTodos().subscribe({
      next: (data: Permissao[]) => {
        this.permissoes = data.map(item => ({label: `${item.descricao} - ${item.tipo}`, value: item}));
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  limparFormulario(){
    this.form?.reset(); 
  }
  
}
